export default {
  data() {
    return {
      dataState: [
        { id: '0', text: 'Tất cả' },
        { id: 'ACTIVE', text: 'Đang hoạt động' },
        { id: 'LOCK', text: 'Đã khoá' },
        { id: 'CLOSE', text: 'Đã đóng' },
      ],
    }
  },
  methods: {
    transformData(data, dataConfig) {
      const dataReturn = dataConfig.filter(e => e.id === data)
      if (dataReturn.length === 0) {
        return ''
      }
      return dataReturn[0].text
    },
  },
  filter: {
    transformData(data, dataConfig) {
      const dataReturn = dataConfig.filter(e => e.id === data)
      if (dataReturn.length === 0) {
        return ''
      }
      return dataReturn[0].text
    },
  },
}
